import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DataServer } from "../../../config.axios";
import { toggleLoading } from "../LoadingSlice";
import { fetchCompleteAssessment } from "../TPIReport/CompleteAssessment";
import { fetchTpiReportedIssuesList } from "../Issues";
import { toast } from "react-toastify";

export interface ReportIssueData {
  assigned_to: string;
  assigned_by: string;
  action_required: string;
  comment: string;
  reported_issue_id: any;
  warehouse_id: number;
}

interface ReportIssueState {
  reportissue: {
    load: boolean;
    data: Array<ReportIssueData>;
  };
  reportIssueData?: ReportIssueData;
}

const initialState = {
  reportissue: {
    load: false,
    data: [],
  },
  reportIssueData: {
    assigned_to: "",
    assigned_by: "",
    action_required: "",
    comment: "",
    reported_issue_id: "",
    warehouse_id: 0,
  },
} as ReportIssueState;

export const reportIssueSlice = createSlice({
  name: "reportissue",
  initialState,
  reducers: {
    resetIssueData: (state: ReportIssueState) => {
      state.reportIssueData = initialState.reportIssueData;
    },
    updateIssueData: (state: ReportIssueState, action: { payload: ReportIssueData }) => {
      state.reportIssueData = action.payload;
    },
  },
});

export const { resetIssueData, updateIssueData } = reportIssueSlice.actions;

export default reportIssueSlice.reducer;


export const ReportIssue = createAsyncThunk(
  "reportissue/ReportIssue",
  async (param: any, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());

      const { data } = await DataServer.post(`api/postReportedIssueVerify`, {
        reported_issue_pin: param.apiParam.id,
        reported_by: param.apiParam.reported_by,
        action_required: param.apiParam.reportIssueData.action_required,
        assigned_to: param.apiParam.reportIssueData.assigned_to,
        warehouse_id: param.apiParam.reportIssueData.warehouse_id,
        assigned_by: param.apiParam.reportIssueData.assigned_by,
        comment: param.apiParam.reportIssueData.comment,
      });
      thunkAPI.dispatch(toggleLoading());

      toast.success(data.message,{theme: "colored", onClose: () => {param.apiParam.reported_by === "TPI" ? handleonConfirm1() : handleonConfirm()}});
      
      const handleonConfirm = () => {
        param.navigation("/reported-issue-summary");
        thunkAPI.dispatch(resetIssueData());
      };
      
      const handleonConfirm1 = () => {
        param.navigation("/compare-statistics");
        thunkAPI.dispatch(resetIssueData());
      };

    } catch (error) {
      toast.error("Something went wrong!",{theme: "colored"});
      thunkAPI.dispatch(toggleLoading());
      thunkAPI.dispatch(resetIssueData());
      return error;

    }
});
  
export const ReportTpiIssue = createAsyncThunk(
  "reportissue/ReportIssue",
  async (param: any, thunkAPI) => {
    try {
      const { data } = await DataServer.post(`api/tpiReportedIssueVerify`, {
        tpi_reported_issue_pin: param.apiParam.id,
        reported_by: param.apiParam.reported_by,
        action_required: param.apiParam.action,
        comment: param.apiParam.comment,
        severity: param.apiParam.severity,
        flag: param.apiParam.flag,
        verification_type: param.apiParam.verification_type,
        project_pin: param.apiParam.project_pin,
        issues: JSON.stringify(param.apiParam.issues),
        login_user_id: param.apiParam.login_user_id,
        selectall: param.apiParam.selectall
      });

      toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});
      
      param.apiParam.setLoader(false);
      const handleonConfirm = () => {
        localStorage.removeItem("state");
        if(param.apiParam.verification_type){
          thunkAPI.dispatch(fetchCompleteAssessment({ apiParam: { project_pin: param.apiParam.project_pin, layout_id: param.apiParam?.LayoutPin } }));
          thunkAPI.dispatch(fetchTpiReportedIssuesList({
            apiParam: {
                per_page: param.apiParam.countPerPage,
                page: param.apiParam.page,
                project_pin: param.apiParam.project_pin,
                search: param.apiParam.searchdata,
                layout_id: param.apiParam.LayoutPin,
                verification_type: ""
            }
        }));
        }
        param.navigation(`/project-reported-issue`, {state: {WarehouseTimeZone: param.apiParam.timezone, ActiveTab: param.apiParam.ActiveTab, countPerPage: param.countPerPage, Page: param.Page, debouncedSearchValue: param?.apiParam?.debouncedSearchValue, project_pin: param.apiParam.project_pin, LayoutPin: param.apiParam?.LayoutPin, CompanyPin: param.apiParam.CompanyPin, WarehousePin: param.apiParam.WarehousePin}});
        thunkAPI.dispatch(resetIssueData());
      };

      return data.data;

    } catch (error) {
      toast.error("Something went wrong!",{theme: "colored"});
      return error;

    }
});

export const UpdateReportIssue = createAsyncThunk(
  "reportissue/UpdateReportIssue",
  async (param: { apiParam: {id: any, reportIssueData: any}, navigation: any }, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());

      const { data } = await DataServer.post(`api/updateAction`, {
        reported_issue_pin: param.apiParam.id,
        action_required: param.apiParam.reportIssueData.action_required,
        assigned_to: param.apiParam.reportIssueData.assigned_to,
        warehouse_id: param.apiParam.reportIssueData.warehouse_id,
        assigned_by: param.apiParam.reportIssueData.assigned_by,
        comment: param.apiParam.reportIssueData.comment,
      });
      thunkAPI.dispatch(toggleLoading());

      toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

      const handleonConfirm = () => {
        param.navigation("/verified-issue-summary");
      };


    } catch (error) {
      toast.error("Something went wrong!",{theme: "colored"});
      thunkAPI.dispatch(toggleLoading());
      return error;
    }
});
